import type { ColumnDef } from "@tanstack/react-table";
import type {
  PayrollRosterDraftMember,
  PayrollRosterField,
} from "@/payroll/roster/types";
import {
  comparePayrollRosterValues,
  formatRosterValue,
  normalizePayrollRosterSortValue,
} from "@/payroll/roster/utils";
import { FIELD_COLUMN_MIN_WIDTH } from "./column-widths";
import { rosterColumnHeader } from "./header";
import { RosterCellValue } from "./roster-cell-value";

export const RosterFieldCol = (
  field: PayrollRosterField,
  width = FIELD_COLUMN_MIN_WIDTH,
): ColumnDef<PayrollRosterDraftMember> => ({
  id: `field-${field.key}`,
  accessorFn: ({ member }) =>
    normalizePayrollRosterSortValue(member.field_values[field.key]),
  header: rosterColumnHeader(field.label),
  sortUndefined: "last",
  sortingFn: (left, right) =>
    comparePayrollRosterValues(
      left.original.member.field_values[field.key],
      right.original.member.field_values[field.key],
      field.field_type,
    ),
  meta: { size: `${width}px` },
  cell: ({ row }) => (
    <RosterCellValue
      value={formatRosterValue(
        row.original.member.field_values[field.key],
        field,
      )}
    />
  ),
});
